// Centralized site-level SEO constants.
//
// IMPORTANT: use SITE_URL (not window.location.origin) for canonical/OG URLs.
// During build-time prerendering (react-snap) window.location.origin is the
// local snapshot server (http://localhost:<port>), which would bake a wrong
// canonical into the static HTML. SITE_URL is always the real production host.
//
// The production domain is systemdesignlab.in (matches the backend CORS allow
// list). Override at build time with REACT_APP_SITE_URL if the domain changes.
export const SITE_URL = (process.env.REACT_APP_SITE_URL || 'https://systemdesignlab.in').replace(/\/+$/, '');

// Build an absolute canonical URL for a given path.
// canonical('/')            -> https://systemdesignlab.in/
// canonical('/learn')       -> https://systemdesignlab.in/learn
// canonical('/learn/x')     -> https://systemdesignlab.in/learn/x
export const canonical = (path = '/') => {
  if (!path || path === '/') return `${SITE_URL}/`;
  return `${SITE_URL}${path.startsWith('/') ? path : `/${path}`}`;
};
